/** Routes that render live-tracking UI (map/detections) and therefore get the
 *  realtime telemetry HUD in AppChrome and the "map mode" full-bleed layout. */
export const TRACKING_ROUTES = ["/", "/map", "/live-detections"] as const

export function isTrackingRoute(pathname: string): boolean {
  return (TRACKING_ROUTES as readonly string[]).includes(pathname)
}
